// Единственный экземпляр клиента запросов.
//
// HEAL-76: вынесен из main.tsx, потому что к нему обращается код вне React —
// слушатель тапа по push-уведомлению (lib/push.ts). Он ставится до монтирования
// приложения, хуками пользоваться не может, а сбросить кэш профиля ему надо:
// в профиле живёт счётчик непрочитанных.

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // ⚠️ Выключено ГЛОБАЛЬНО, дальше каждый запрос решает сам.
      //
      // Профиль включает его обратно (api/hooks/profile.ts): возврат приложения
      // из фона — момент, когда счётчик уведомлений устаревает. Состояние
      // приложения Capacitor подключено к менеджеру фокуса в lib/app-focus.ts.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});
